import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

const GetContent = () => {
  const { id } = useParams();
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const server_url = process.env.REACT_APP_API_URI;

  useEffect(() => {
    fetch(`${server_url}/content/get-content/${id}`)
      .then((response) => response.json())
      .then((data) => {
        if (data && data.data) {
          setContent(data.data);
        } else {
          throw new Error('Content not found');
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error('Fetch error:', err);
        setError('Failed to fetch Content.');
        setLoading(false);
      });
  }, [id]);

  useEffect(() => {
    const loadCKEditorScript = () => {
      const existingScript = document.querySelector(
        'script[src*="ckeditor.js"]',
      );
      if (!existingScript) {
        const script = document.createElement('script');
        script.src =
          'https://cdn.ckeditor.com/ckeditor5/41.4.2/decoupled-document/ckeditor.js';
        script.onload = initializeEditors;
        document.body.appendChild(script);
      } else {
        initializeEditors();
      }
    };

    const initializeEditors = () => {
      if (!window.DecoupledEditor || !content?.sections) return;

      content.sections.forEach((section) => {
        section.contents.forEach((item) => {
          const container = document.getElementById(`editor_${item._id}`);
          if (container && !container.dataset.loaded) {
            window.DecoupledEditor.create(container, { toolbar: [] })
              .then((editor) => {
                editor.setData(item.content || '');
                editor.enableReadOnlyMode('readOnlyView');
                container.dataset.loaded = 'true';
              })
              .catch((error) => {
                console.error('Editor initialization error:', error);
              });
          }
        });
      });
    };

    if (content?.sections) {
      loadCKEditorScript();
    }
  }, [content]);

  if (loading) return <p>Loading content...</p>;
  if (error) return <p className="text-red-500">{error}</p>;

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-4">{content.mainTitle}</h2>
      {content.sections.map((section) => (
        <div key={section._id} className="mb-6">
          <h3 className="text-xl font-semibold mb-2">{section.title}</h3>
          {section.contents.map((item) => (
            <div key={item._id} className="border p-2 mb-4 rounded">
              <div
                id={`editor_${item._id}`}
                className="ck-content"
                style={{
                  minHeight: '200px',
                  backgroundColor: '#f9f9f9',
                  padding: '1rem',
                }}
              ></div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default GetContent;
